import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { ContactUsModel } from '../model/ContactUsModel';
import { ContactUsController } from '../controller/ContactUsController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { Paper } from 'components/paper';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';
import { FeedbackPaper } from './FeedbackPaper';

export class ContactUsScene extends AScene<Props, ContactUsModel, ContactUsController> {

    public constructor(props: Props) {
        super(props);
    }

    protected createControlller(): ContactUsController {
        return new ContactUsController();
    }



    render(): React.ReactNode {
        return (
            <div style={{ width: '100%', padding: '64px' }}>
                <FeedbackPaper controller={this.controller} />

                <Paper title="Channels" desc="You can contact us on any of the following channels">
                    <div><b>Email: </b> info@humen.io</div>
                    <div><b>Facebook: </b> <a href="https://www.facebook.com/humenio" target="_blank">@humenio</a></div>
                    <div><b>Twitter: </b> <a href="https://twitter.com/humenapp" target="_blank">@humenapp</a></div>
                </Paper>
            </div>
        )
    }


}

export interface Props {

}

export class ContactUsSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <ContactUsScene />
        );
    }

}